import { Box, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import dayjs from 'dayjs';
import { tokens } from '../../theme';
import { useCommonReducer } from '../../redux/slice/commonSlice';
import { useBranding } from "../../BrandingContext";

const Footer: React.FC = () => {
    const thisYear = dayjs().format('YYYY');
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { appConfigList } = useCommonReducer();
    
     const branding = useBranding();

    const appVersion = React.useMemo(() => {
        let storedVersion = localStorage.getItem('applicationVersion');
        if (storedVersion == null) {
            storedVersion = '1.0';
        }
        return storedVersion;
    }, [appConfigList]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
            }}
        >
            <Box className="footer fixed-bottom" p={1} style={{ backgroundColor: colors.grey[900] }}>
                <div className="footer-text">
                    <span>
                        {branding?.companyNameShort === "V3Bio" ? `Copyright © ${thisYear} ${branding?.companyName || 'V3 BioMedical'}` : branding?.footerCopyright}
                        {appVersion && ` ${appVersion}`}
                    </span>
                    {/* Copyright © ${thisYear} - Removed for now and handled it from config due to woundwave env changes */}
                    {/* CS-1602 - Made dynamic Privacy Policy link fetched from branding config */}
                    <a href={branding?.privacyPolicyUrl} target="_blank" rel="noreferrer noopener" style={{ textDecoration: "none", color: colors.info[300], marginLeft: "10px" }}>
                        {/* <a href="/privacy.html"  target="_blank" rel="noreferrer noopener" style={{ textDecoration: "none", color: colors.info[300],marginLeft:"10px"}}> */}
                        Privacy Policy
                    </a>
                    <a href={branding?.termsAndConditionsUrl} target="_blank" rel="noreferrer noopener" style={{ textDecoration: "none", color: colors.info[300], marginLeft: "10px" }}>
                        Terms & Conditions
                    </a>
                </div>
            </Box>
        </Box>
    );
};

export default Footer;
